import { defineAction } from '~/prix'
import citizenGetGeoAction from './citizenGet.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const citizenGetGeoDefinition = defineAction({
  ...citizenGetGeoAction,

  input: z.object({
    id: z.string(),
  }),
  output: z.object({
    originalId: z.string(),
    dataSourceId: z.string(),
    cpf: z.string().nullish(),
    cns: z.string().nullish(),
    name: z.string(),
    socialName: z.string().nullish(),
    birthDate: dateOrIsoString().nullish(),
    sex: z.string().nullish(),
    genderIdentity: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    deceased: z.boolean().nullish(),
    healthUnitCnes: z.string().nullish(),
    teamIne: z.string().nullish(),
    streetName: z.string().nullish(),
    streetNumber: z.string().nullish(),
    complement: z.string().nullish(),
    neighborhood: z.string().nullish(),
    referencePoint: z.string().nullish(),
    postalCode: z.string().nullish(),
    municipality: z.string().nullish(),
    state: z.string().nullish(),
    deathDate: dateOrIsoString().nullish(),
    createdAt: dateOrIsoString().nullish(),
    updatedAt: dateOrIsoString().nullish(),
    isDeleted: z.boolean().nullish(),
    citizenGeo: z
      .object({
        originalId: z.string().nullish(),
        dataSourceId: z.string().nullish(),
        longitude: z.number(),
        latitude: z.number(),
        longitudeOnStreet: z.number().nullish(),
        latitudeOnStreet: z.number().nullish(),
        distanceOfStreet: z.number().nullish(),
        angleFromStreet: z.number().nullish(),
        accuracy: z.number().nullish(),
        source: z.string().nullish(),
        geocodingQuality: z.string().nullish(),
        geocodingQualityScore: z.number().nullish(),
        buildingId: z.number().nullish(),
        streetId: z.string().nullish(),
        neighborhoodId: z.string().nullish(),
        districtId: z.number().nullish(),
        municipalityId: z.string().nullish(),
        microRegionId: z.string().nullish(),
        mesoRegionId: z.string().nullish(),
        stateId: z.string().nullish(),
        macroRegionId: z.string().nullish(),
        countryId: z.string().nullish(),
        createdAt: dateOrIsoString().nullish(),
        updatedAt: dateOrIsoString().nullish(),
        isDeleted: z.boolean().nullish(),
      })
      .nullish(),
  }),
})

export default citizenGetGeoDefinition
